import { defineComponent } from "vue"; // helpers

import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal"; // constants

import { ModalStatus } from "@/constants/modal";
export default defineComponent({
  name: "Preferences",
  components: {},
  setup: function setup() {
    var modalVisibility = dialogVisibleForStatus(ModalStatus.Preferences);
    return {
      modalVisibility: modalVisibility
    };
  }
});